import type { FaireProductEntity } from "../../entity_types/product";

export const p_7eyr9z5n7s: FaireProductEntity = {
  token: "p_7eyr9z5n7s",
  type: "product",
  name: "Alya Mini Drop Earrings",
  brandToken: "b_xwgv2hs87j",
  brandName: "Leeada Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/3625aa494c58a57b8f0e117d7d6aecb8ea5d508948d3f8daa091e506beabead8.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.75,
  description:
    "The Alya Mini Drop Earrings from Leeada Jewelry are dangle earrings that are on trend, but not trendy, youthful but mature. These earrings are part of a collection that evokes a spirit that glides gracefully through the seasons. They are a product of a women-owned brand that loves jewelry as much as you do.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:40.240Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
